import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { DELETE_NOTIFICATION_TEMPLATE_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request
// =============================================================================
interface DeleteNotificationTemplateRequest {
  uuid: string;
  notificationType: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useDeleteNotificationTemplate = ({ onSuccess, onError }: Input) => {
  const deleteNotificationTemplate = async ({
    uuid,
    notificationType,
  }: DeleteNotificationTemplateRequest) => {
    await axiosClient.delete<void>(DELETE_NOTIFICATION_TEMPLATE_URL(uuid), {
      data: {
        notificationType,
      },
    });
  };

  return useCustomMutation(deleteNotificationTemplate, {
    onSuccess,
    onError,
  });
};
